export default function main() {
    const $accordionButtons = Array.from(document.querySelectorAll('.accordion-button'));
    for (const $btn of $accordionButtons) {
        ['mousedown', 'touchstart'].forEach(e => {
            $btn.addEventListener(e, () => {
                $btn.classList.add('mousedown');
            });
        });

        ['mouseup', 'mouseleave', 'touchend'].forEach(e => $btn.addEventListener(e, () => {
            $btn.classList.remove('mousedown');
        }),
        );
    }

    const $categorySelectionInputs = Array.from(document.querySelectorAll('input[name="category-selection"]')) as HTMLInputElement[];
    $categorySelectionInputs[0].checked = true;

    for (const $input of $categorySelectionInputs) {
        $input.addEventListener('input', () => {
            const $checkedCategorySelectionInput: HTMLInputElement = Array.from(document.querySelectorAll('input[name="category-selection"]:checked'))[0] as HTMLInputElement;
            hideShowCategoryQuestions($checkedCategorySelectionInput);
        });
    }
    $categorySelectionInputs[0].dispatchEvent(new Event('input'));

    function hideShowCategoryQuestions($checkedEl: HTMLInputElement) {
        const $hideQuestions = Array.from(document.querySelectorAll('.questions-container'));
        for (const $el of $hideQuestions) {
            if ($el.id !== $checkedEl.value) {
                $el.classList.add('d-none');
                const $accordionButtons = Array.from($el.querySelectorAll('.accordion-button')) as HTMLButtonElement[];
                const $accordionBodies = Array.from($el.querySelectorAll('.accordion-collapse')) as HTMLElement[];
                for (const $btn of $accordionButtons) {
                    $btn.setAttribute('aria-expanded', 'false');
                    $btn.classList.add('collapsed');
                }
                for (const $body of $accordionBodies) {
                    $body.classList.remove('show');
                }
            } else {
                $el.classList.remove('d-none');
            }
        }
    }
}